import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ReportViewDto } from "../../../api/models/report-view-dto";
import { ReportType } from "../../../server/enums/report-type.enum";

@Component({
    selector: "app-view-modal",
    templateUrl: "./view-modal.component.html",
    styleUrl: "./view-modal.component.scss",
    standalone: false
})
export class ViewModalComponent {
  constructor(public modal: NgbActiveModal) {}
  data?: { reports?: ReportViewDto[] };

  protected readonly ReportType = ReportType;

  getLastUpdatedDate(report: ReportViewDto) {
    return [...report.reportEntries?.map((re) => re?.updatedDate), report.updatedDate].reduce((a, b) =>
      a > b ? a : b
    );
  }
}
